import React, { useState } from "react";

function AllJobsPopup({ shortDescription, longDescription }) {

  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const getShortenedDescription = (text, wordLimit) => {
    const words = text.split(" ");
    if (words.length <= wordLimit) {
      return text;
    }
    return words.slice(0, wordLimit).join(" ") + ".......... ";
  };
  
  const isLongDescriptionShort = longDescription.split(" ").length <= 40;

  return (
    <>
      <div
        className="modal fade twm-sign-up"
        id="job-type-popup"
        aria-hidden="true"
        aria-labelledby="job_type_popupLabel"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form>
              <div className="modal-header" style={{ marginTop: "0px" }}>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body"
              >
                {/* <h4>Short Description:</h4> */}
                <p>{shortDescription}</p>
                {/* <h4>Long Description:</h4> */}
                <div className="twm-s-info-inner">
                  <span className="profession-list-long-desc-text"
                    dangerouslySetInnerHTML={{
                      __html: isExpanded || isLongDescriptionShort
                        ? longDescription
                        : getShortenedDescription(longDescription, 40),
                    }}
                  />
                  {!isLongDescriptionShort && (
                  <span style={{ whiteSpace: 'nowrap' }}
                    onClick={handleToggleExpand}
                  >
                    <b><a
                      className="site-text-primary job-details"
                      style={{ cursor: 'pointer' }}
                      onClick={handleToggleExpand}>
                      {isExpanded ? "Show less" : "Read more"}
                    </a></b>
                  </span>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllJobsPopup;